/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * What a row of a royalty export is: one invoice line, or one day behind it.
 */
export type RoyaltyExportGranularity = typeof RoyaltyExportGranularity[keyof typeof RoyaltyExportGranularity];


export const RoyaltyExportGranularity = {
  daily: 'daily',
  monthly: 'monthly',
} as const;
